import * as joi from "joi";

export const alertDataSchema = joi.object().keys({
    alertName: joi.string().trim().required(),
    triggerPort: joi.number().positive().allow(null).allow(0),
});
